

































import { Component, Vue, Prop} from 'vue-property-decorator';
import { Effect } from '@/game/effect';
import { Player } from '@/game/player';
import { PlayerOptions, GameOptions } from '@/game';

@Component({
  name: 'options'
})
export default class Options extends Vue {

    public options: GameOptions;
    public players: PlayerOptions[];
    
    private readonly colors = ['#039be5', '#43a047', '#fdd835', '#5e35b1', '#e53935', '#f4511e'];
    private colorIndex = 0;

    private names = ['Lion', 'Squirrel', 'Sheep', 'Raccoon', 'Falcon', 'Elephant', 'Cow', 'Pig'];

    private keys: { left: string, right: string }[] = [];
    private recording?: { player: PlayerOptions, which: 'left' | 'right' };

    constructor() {
        super();
        let options = localStorage.getItem('game.options');
        if (options) {
            this.options = JSON.parse(options);
        } else {
            this.options = {
                players: [],
                enablePowerups: true,
                enableBallSizeVariation: true,
                enableBallSpeedVariation: true,
                showTargets: false
            };
            this.keys = [
                { left: '#', right: '+' },
                { left: 'q', right: 'a' },
                { left: 'ArrowLeft', right: 'ArrowRight' }
            ];
            
        }
        this.players = this.options.players;
    }

    created() {
        document.addEventListener('keydown', this.onKey)
        this.names.sort(el => Math.round(2*Math.random()-1)); // shuffle
        this.colors.sort(el => Math.round(2*Math.random()-1)); // shuffle

        if (this.players.length === 0) {
            for (let i = 0; i < 3; i++) {
                this.add();
            }
        }
    }

    destroyed() {
        this.onKey({ key: '[?]' } as any); // reset if currently recording
        document.removeEventListener('keydown', this.onKey);
    }

    remove(i: number) {
        let p = this.players.splice(i, 1)[0];
        this.names.push(p.name);
        this.keys.push(p.keys);
    }

    add() {
        this.players.push({
            name: this.names.pop() || 'GuestMammal',
            isBot: false,
            color: this.nextColor(),
            keys: this.keys.pop() || { left: '[?]', right: '[?]' }
        });
    }

    nextColor() {
        if (this.colorIndex >= this.colors.length) {
            this.colorIndex = 0;
        }
        return this.colors[this.colorIndex++];
    }

    getKey(p: PlayerOptions, which: 'left' | 'right') {
        switch (p.keys[which]) {
            case 'ArrowLeft': return '←';
            case 'ArrowRight': return '→';
            default: return p.keys[which];
        }
    }

    record(player: PlayerOptions, which: 'left' | 'right') {
        this.recording = { player, which };
        if (!player.keys) player.keys = { left: '[?]', right: '[?]' };

        player.keys[which] = '[...]';
    }

    onKey(ev: KeyboardEvent) {
        console.log(ev);
        if (this.recording) {
            this.recording.player.keys[this.recording.which] = ev.key;
            this.recording = undefined;
        }
    }

    start() {
        this.options.players = this.players;
        localStorage.setItem('game.options', JSON.stringify(this.options));
        this.$emit('start', this.options);
    }

}
